<template>
  <div>
    <ContentHeader :show-back="false" />

    <div class="content-container">
      <!-- 搜索条件 -->
      <div class="search-top-row">
        <el-row>
          <el-col style="text-align:center">
            <el-input
              class="search-input"
              v-model="queryParam.keyword"
              placeholder="关键字搜索"
            >
              <i slot="suffix" class="el-input__icon el-icon-search"></i>
            </el-input>

            <el-select
              v-model="queryParam.channel"
              placeholder="选择渠道"
              clearable
              filterable
            >
              <el-option
                v-for="(item, index) in channelList"
                :key="index"
                :value="item.channelName"
                :label="item.channelName"
              />
            </el-select>

            <el-select
              v-model="queryParam.abiBrandId"
              placeholder="选择品牌"
              clearable
              filterable
            >
              <el-option
                v-for="(item, index) in brandList"
                :key="index"
                :value="item.abiBrandId"
                :label="item.abiBrandName"
              />
            </el-select>

            <span class="search-text">价格区间</span>
            <el-input
              v-model="queryParam.minPrice"
              class="range-input"
              @keyup.native="minNumber"
            ></el-input>
            <span class="search-text">至</span>
            <el-input
              v-model="queryParam.maxPrice"
              class="range-input input-right"
              @keyup.native="maxNumber"
            ></el-input>

            <el-button class="btn-red" size="small" @click="handleFilter"
              >搜索</el-button
            >
          </el-col>
        </el-row>
      </div>
      <div class="shelter">
        <!-- 商品列表 -->
        <div
          class="item-list"
          v-loading="loading"
          v-infinite-scroll="getMore"
          :infinite-scroll-distance="20"
          :infinite-scroll-disabled="moreDisabled"
        >
          <div
            class="item-card"
            v-for="(item, index) in groupList"
            :key="index"
          >
            <router-link
              style="width:100%;"
              :to="{path: `/material/item-detail/${item.itemId}`}"
            >
              <div class="item-card-info">
                <div class="item-card-left">
                  <img :src="getImageUrl(item)" />
                </div>
                <div class="item-card-center">
                  <p class="font-weight item-title">{{ item.itemName }}</p>
                  <p class="font-weight item-title">
                    {{ getStartTime(item) | parseTime("{y}.{m}.{d}") }} -
                    {{ getEndTime(item) | parseTime("{y}.{m}.{d}") }}
                  </p>
                  <div class="item-progress">
                    <el-progress
                      :stroke-width="18"
                      :text-inside="true"
                      :percentage="getPercentage(item)"
                      :format="getShowQuantity(item)"
                      color="rgb(218, 63, 63)"
                    ></el-progress>
                    <div>{{ getShowMOQ(item) | thousandSymbol}}</div>
                  </div>
                </div>
                <div class="item-card-right">
                  <p class="item-time">{{ getCountTime(item) }}</p>
                  <div class="item-btn">马上拼单</div>
                </div>
              </div>
            </router-link>
          </div>
          <div class="no-data" v-if="!groupList.length">暂无数据</div>
          <div class="more-loading" v-if="groupList.length && !noMore">loading···</div>
          <div class="more-loading" v-if="groupList.length && noMore">暂无更多物料</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import baseApi from '@/api/base'
import { commonUtils } from '@/utils/common'
import ContentHeader from '@/components/content-header'
export default {
  name: 'group-list',
  components: {
    ContentHeader
  },
  data () {
    return {
      loading: false,
      moreLoading: false,
      channelList: [],
      brandList: [],
      intervalDate: 28, // 间隔日期
      groupList: [],
      totalPages: 0,
      curPage: 0,
      queryParam: {
        channel: '',
        keyword: '',
        abiBrandId: '',
        minPrice: '',
        maxPrice: '',
        pageSize: 20,
        page: 1
      }
    }
  },
  computed: {
    noMore () {
      return this.curPage >= this.totalPages
    },
    moreDisabled () {
      return this.moreLoading || this.noMore
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.getChannel()
      this.getBrand()
      this.getGroupList()
    },

    // 触底加载
    getMore () {
      this.moreLoading = true
      this.queryParam.page++
      this.getGroupList(true)
    },

    // 获取拼单列表
    getGroupList (isMore) {
      this.loading = !isMore
      this.$store
        .dispatch('queryGroupList', this.queryParam)
        .then(res => {
          this.moreLoading = false
          this.loading = false
          if (res.data.resultCode === '0') {
            this.groupList = this.groupList.concat(
              res.data.resultData.spellPocmList
            )
            this.totalPages = res.data.resultData.pageInfo.totalPages
            this.curPage = res.data.resultData.pageInfo.curPage
          }
        })
        .catch(() => {
          this.moreLoading = false
          this.loading = false
        })
    },

    // 获取订单的开始时间 以次日0点为标准
    getStartTime (item) {
      return new Date(
        new Date(item.approveDate + 24 * 60 * 60 * 1000).toLocaleDateString()
      ).getTime()
    },

    // 获取订单结束日期 以次日0点为标准
    getEndTime (item) {
      let timestamp =
        item.approveDate + this.intervalDate * (24 * 60 * 60 * 1000)
      let time = new Date(
        new Date(timestamp + 24 * 60 * 60 * 1000).toLocaleDateString()
      ).getTime()
      this.$set(item, 'orderEndDate', time)
      return time
    },

    // 获取时间差
    getCountTime (item) {
      let start = new Date().getTime()
      let end = item.orderEndDate
      let countTime = end > start ? end - start : start - end
      let info = end > start ? '还有' : '超出'
      let countDay = Math.floor(countTime / (24 * 60 * 60 * 1000))
      return info + countDay + '天'
    },

    // 图片处理
    getImageUrl (item) {
      let imageUri = ''
      if (item.imageList && item.imageList.length > 0) {
        imageUri = item.imageList[0].imageFileUri
      }
      return commonUtils.getImageUrl(imageUri)
    },

    // 计算百分比 （采购数量/最低起订量）*100
    getPercentage (item) {
      return item.sumPurchaseQuantity < Number(item.factoryMOQ)
        ? (item.sumPurchaseQuantity / Number(item.factoryMOQ)) * 100
        : 100
    },

    // 进度条内部显示数值 采购数量
    getShowQuantity (item) {
      return () => {
        return item.sumPurchaseQuantity < Number(item.factoryMOQ)
          ? item.sumPurchaseQuantity
          : ''
      }
    },
    // 进度条尾部显示数值 最低起订量
    getShowMOQ (item) {
      return item.sumPurchaseQuantity < Number(item.factoryMOQ)
        ? item.factoryMOQ
        : '满'
    },

    // 查询
    handleFilter () {
      this.groupList = []
      this.queryParam.page = 1
      this.getGroupList()
    },

    minNumber () {
      // eslint-disable-next-line no-useless-escape
      this.queryParam.minPrice = this.queryParam.minPrice.replace(/[^\.\d]/g, '').replace('.', '')
    },

    maxNumber () {
      // eslint-disable-next-line no-useless-escape
      this.queryParam.maxPrice = this.queryParam.maxPrice.replace(/[^\.\d]/g, '').replace('.', '')
    },

    // 渠道
    getChannel () {
      baseApi.getChannel().then(res => {
        if (res.data.resultCode === '0') {
          this.channelList = res.data.resultData.baseChannelList
        }
      })
    },

    // 品牌
    getBrand () {
      baseApi.getBrand().then(res => {
        if (res.data.resultCode === '0') {
          this.brandList = res.data.resultData.brandList
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
$base-width: 150px;
.shelter{
  width:1180px;
  overflow: hidden;
}
.item-list {
  width:1200px;
  height: calc(100vh - 320px);
  overflow-y: auto;
  .item-card {
    overflow: hidden;
    border-radius: 10px;
    box-sizing: border-box;
    display: inline-block;
    width: 48%;
    height: 130px;
    // height: 1000px;
    margin: 10px;
    overflow: hidden;
    background: #fff;
    .item-card-info {
      display: flex;
      width: 100%;
      height: 100%;
      .item-card-left {
        width: 40%;
        background-color: rgb(232, 232, 232);
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          max-height: 100%;
          max-width: 100%;
        }
      }
      .item-card-center {
        padding: 15px;
        width: 100%;
      }
      .item-card-right {
        width: 25%;
        padding: 10px;
      }
    }
  }
}
.font-weight {
  font-weight: 700;
}
.item-title {
  width: 250px;
  font-size: 15px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.item-price {
  font-size: 13px;
  color: rgb(218, 63, 63);
}
.item-time {
  text-align: center;
  font-size: 12px;
  color: #aaa;
}
.item-progress {
  display: flex;
  color: #888;
  .el-progress {
    width: 80%;
    margin-right: 5px;
  }
}
.item-btn {
  font-size: 12px;
  text-align: center;
  color: #fff;
  padding: 7px 0px;
  border-radius: 50px;
  background-color: rgb(239, 73, 73);
  width: 70px;
  margin-top: 35px;
}
::v-deep .el-progress-bar__outer {
  background-color: rgb(239, 171, 171);
}

.more-loading {
  text-align: center;
  color: #aaa;
}
.search-input.el-input {
  width: $base-width;
  height: 36px;
  margin: 0 20px 20px 0;
  input::-webkit-input-placeholder {
    color: #000;
  }
}
.el-select {
  width: $base-width;
  height: 36px;
  margin: 0 20px 20px 0;
}
.search-text {
  font-size: $font-12;
  display: inline-block;
  height: 38px;
  padding: 0 5px;
  line-height: 38px;
  background-color: #d8d8d8;
}

.range-input {
  width: $base-width;

  ::v-deep .el-input__inner {
    padding: 0 5px;
  }
}
.input-right {
  margin-right: 20px;
}
.budget-grid-info {
  margin-top: 20px;
}
</style>
